import { groupResource } from '@witkac/kartamiejska-resources';
import { RouteConfig } from 'vue-router';

import { LocalStorage } from '@/enums/storage.enum';
import store from '@/store';

export const cardRoute: RouteConfig = {
  path: 'card',
  component: () => import(/* webpackChunkName: "VirtualCard" */ '@/views/main/VirtualCard.vue'),
  name: 'card',
  beforeEnter(to, from, next) {
    const userId = localStorage.getItem(LocalStorage.USER_ID);
    store.commit('profile/setId', userId);
    Promise.all([
      store.dispatch('settings/get', 'CARD_STATE_COLOR'),
      store.dispatch('card/list'),
      store.dispatch('profile/get'),
      groupResource.getUserGroups((userId as any) as number)
    ])
      .then(data => {
        store.commit('profile/setGroups', data[3]);
        return store.dispatch('application/list');
      })
      .then(() => {
        next();
      });
  }
};
